export class ApiCalls {
    static ZIPPOPOTAM_URL = 'https://api.zippopotam.us';
    static OPEN_DATA_SOFT_URL = 'https://public.opendatasoft.com/api/records/1.0/search';
}